import { Round } from './pages/Game/Game';

const defaultRounds: Round[] = [
	{
		levels: [200, 400, 600, 800, 1000],
		categories: [],
	},
	{
		levels: [400, 800, 1200, 1600, 2000],
		categories: [],
	},
	{
		finalJeopardy: true,
		category: '',
		question: {
			text: '',
			answer: '',
		},
	},
];

export default defaultRounds;
